import { callMdaeApi } from "../../../../call-web-api";
import { throwExceptionErrors } from "../../../../utils/fetch";

// Shared GET helper for the Risk Areas (New Experience) v1 endpoints.
//
// callMdaeApi prefixes every request with the enterprise API base URL cached in
// sessionStorage ('mdae-api-new-base-url'), seeded from the backend config key
// MdaeApiBaseUrl.
const BASE_URL_KEY = "mdae-api-new-base-url";

// Hard ceiling for any single request. callMdaeApi's own steps (resolving the
// base URL, the okta token) carry no timeout of their own, so a stalled
// enterprise host would otherwise leave the page stuck on "Loading…" forever.
const REQUEST_TIMEOUT_MS = 15000;

const withTimeout = <T>(promise: Promise<T>, ms: number, label: string): Promise<T> => {
  let timer: ReturnType<typeof setTimeout>;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      const e: any = new Error(`Request timed out after ${ms}ms`);
      e.status = 0;
      e.statusText = "timeout";
      e.url = label;
      e.isTimeout = true;
      reject(e);
    }, ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer)) as Promise<T>;
};

export const callEnterpriseApi = async (path: string) => {
  let base = "";
  try { base = window.sessionStorage.getItem(BASE_URL_KEY) || ""; } catch (e) { /* noop */ }
  try {
    const response = await withTimeout(
      callMdaeApi({ type: "GET", url: path }),
      REQUEST_TIMEOUT_MS,
      base + path
    );
    throwExceptionErrors(response as any);
    return response;
  } catch (err) {
    throw err;
  }
};
